<template lang="html">
  <Row type="flex" jsutify="start" align="top" style="padding-bottom: 38px; padding-left: 18vw; padding-right: 18vw">
    <div v-for="section in content">
      <h2 class="section-title"><strong>{{ section.title }}</strong></h2>
      <div>
        <p
          v-if="typeof paragraph === 'string'"
          v-for="paragraph in section.content"
          class="content-item"
          :class="{ 'no-margin': section.title === 'Contact Information' }">
          {{paragraph}}
        </p>
        <ul
          v-else-if="paragraph.type === 'ul'"
          class="content-item">
          <li v-for="listItem in paragraph.items">{{ listItem }}</li>
        </ul>
        <p 
          v-else-if="paragraph.type === 'i'"
          class="content-item">
          <i>{{ paragraph.content }}</i>
        </p>
      </div>
    </div>
  </Row>
</template>
<script>
export default {
  props: { content: Array },
};
</script>
<style type="css" scoped>
.section-title {
  font-size: 1.5rem;
}

.content-item {
  margin-bottom: 16px;
  font-size: 14px;
}

.no-margin {
  margin-bottom: unset;
}

ul { margin-left: 18px; }
li { list-style-type: circle; }
</style>


// WEBPACK FOOTER //
// src/components/DenseContent.vue